import { isElement } from "./instanceOf.js";
export default function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}


//////////////////
// WEBPACK FOOTER
// /Users/amaurypeillon/Local Sites/sfennetwork/app/public/wp-content/themes/pitch-theme/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
// module id = 5
// module chunks = 0